import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { TransitionMotion, spring } from 'react-motion'
import styles from './filter-tags.styl'

export default class Tags extends Component {
  static propTypes = {
    onUpdate: PropTypes.func,
    tags: PropTypes.array,
    lists: PropTypes.array
  }

  handleRemove = id => {
    const updatedTags = this.props.tags
      .filter(item => item.id !== id)
      .map(item => ({
        [item.id]: item.value
      }))

    this.props.onUpdate(updatedTags, id)
  }

  willEnter = () => {
    return { size: 0.8, opacity: 0 }
  }

  willLeave = () => {
    return {
      size: spring(0.8, { stiffness: 300, damping: 30 }),
      opacity: spring(0, { stiffness: 300, damping: 30 })
    }
  }

  handleFindLabel = () => {
    const { tags, lists } = this.props
    let selectValue = ''

    if (lists && lists.length > 0) {
      tags.forEach(tag => {
        lists.forEach(list => {
          selectValue = list
            .map(item => item.value === tag.value && item.label)
            .filter(item => item)
            .join() // eslint-disable-line
        })
      })
    }
    return selectValue
  }

  render() {
    const { tags } = this.props
    const selectValue = this.handleFindLabel() || null

    return (
      <TransitionMotion
        willEnter={this.willEnter}
        willLeave={this.willLeave}
        styles={tags.map(tag => ({
          key: tag.id,
          data: tag,
          style: {
            size: spring(1, { stiffness: 300, damping: 30 }),
            opacity: spring(1, { stiffness: 300, damping: 30 })
          }
        }))}
      >
        {interpolatedStyles => (
          <div className={styles.tags}>
            {interpolatedStyles.map(({ key, data, style }) => {
              return (
                <span
                  key={key}
                  className={styles.tag}
                  style={{
                    opacity: style.opacity,
                    transform: `scale3d(${style.size}, ${style.size}, ${style.size})`
                  }}
                >
                  <span className={styles.value}>
                    {selectValue || data.value}
                  </span>
                  <button
                    className={styles.btn}
                    type="button"
                    onClick={() => this.handleRemove(data.id)}
                  >
                    <span className="ico ico--clear" />
                  </button>
                </span>
              )
            })}
          </div>
        )}
      </TransitionMotion>
    )
  }
}
